import { PricingPlan } from './pricingPlan'

export function Pricing() {
	return (
		<section id="pricing" className="max-w-[1000px] mx-auto space-y-8 py-24">
			<div className="space-y-4 text-center">
				<h2 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
					Simple, transparent pricing
				</h2>
				<p className="mx-auto max-w-2xl text-lg text-muted-foreground"></p>
			</div>

			<div className="grid gap-8 pt-12 lg:grid-cols-3 lg:gap-6">
				<PricingPlan
					name="Starter"
					price="$0"
					description="Perfect for trying out our services"
					href="#"
					features={[
						'3 free recipes',
					]}
				/>

				<PricingPlan
					featured
					name="Beta Program"
					price="$50"
					description="Exclusive early access with lifetime savings"
					href="#"
					features={[
						'Exclusive lifetime discount – your price never increases!',
						'Early access to new features & priority support',
						'Be instrumental in shaping the future of restaurant tech',
					]}
				/>
				<PricingPlan
					name="Standard"
					price="$75"
					description="Comprehensive plan for restaurants"
					href="#"
					features={[
						'Advanced recipe management',
						'Ingredient cost calculations',
					]}
				/>



			</div>
		</section>
	)
}
